// @flow
import {
    BULB_SAVED,
    CHANGE_BRIGHTNESS,
    CHANGE_COLOR_MODE,
    COLOR_CHANGED,
    TOGGLE_DONE,
    TOGGLE_LIGHTBULB,
    TALK_TO_LIGHT
} from './constants';

import { createAction } from 'redux-actions';
import { createCurriedAction } from '../../createCurriedAction';

export const bulbSaved = createAction(BULB_SAVED);
export const changeColorMode = createAction(CHANGE_COLOR_MODE);
export const changeColor = createAction(COLOR_CHANGED);
export const toggleLightbulb = createAction(TOGGLE_LIGHTBULB);
export const toggleDone = createAction(TOGGLE_DONE);
export const talkToLight = createAction(TALK_TO_LIGHT);

export const changeBrightness = createCurriedAction(CHANGE_BRIGHTNESS, (productId, isOn, brightness) => ({
    productId,
    isOn,
    brightness
}));



// WEBPACK FOOTER //
// ./src/core/state/products/bulbs/actions.js